/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteLeagueResponse
 */
export interface DeleteLeagueResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteLeagueResponse
     */
    message: string;
}

/**
 * Check if a given object implements the DeleteLeagueResponse interface.
 */
export function instanceOfDeleteLeagueResponse(value: object): value is DeleteLeagueResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function DeleteLeagueResponseFromJSON(json: any): DeleteLeagueResponse {
    return DeleteLeagueResponseFromJSONTyped(json, false);
}

export function DeleteLeagueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteLeagueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function DeleteLeagueResponseToJSON(json: any): DeleteLeagueResponse {
    return DeleteLeagueResponseToJSONTyped(json, false);
}

export function DeleteLeagueResponseToJSONTyped(value?: DeleteLeagueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

